import { Table } from 'components-antd';
import styles from './styles.module.scss';
import { Avatar } from 'components';
import { convertNameToAvatarPlaceholder } from 'helpers';
import { Checkbox } from 'antd';
import ClientActionsMenu from '../ClientActionsMenu';

type TeamMemberClientsTablePropsType = {
  clients: any[];
  multiSelectMode: boolean;
  selectedClientIds: number[];
  setSelectedClientIds: Function;
  handleReassignClick: Function;
  limitedAccess: boolean;
};

const TeamMemberClientsTable = (props: TeamMemberClientsTablePropsType) => {
  const {
    clients,
    multiSelectMode,
    selectedClientIds,
    setSelectedClientIds,
    handleReassignClick,
    limitedAccess,
  } = props;
  const clientsIds = clients.map((client) => client.Id);
  const getClientStatus = (client): string => {
    if (client.InvitationStatus === 'Pending') return client.InvitationStatus;

    if (!client.IsActive) return 'Inactive';

    return 'Active';
  };

  const getClientFocus = (client): string => {
    let focus = '';

    if (client.ActiveSearches) focus = 'Buying';
    if (client.ListingCount || client.HasSellingAddress) focus += focus ? ', Selling' : 'Selling';
    if (client.InRetention) focus += focus ? ', Retention' : 'Retention';

    if (!focus) focus = '-';

    return focus;
  };

  const handleCheckboxChange = (e, client) => {
    const isChecked = e.target.checked;
    if (isChecked && !selectedClientIds.includes(client.Id))
      setSelectedClientIds((prev) => [...prev, client.Id]);
    else if (!isChecked && selectedClientIds.includes(client.Id))
      setSelectedClientIds((prev) => prev.filter((id) => id !== client.Id));
  };

  const handleMainCheckboxChange = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      const allClientsIds = clients.map((client) => client.Id);
      setSelectedClientIds(allClientsIds);
    } else setSelectedClientIds([]);
  };

  const getColumns = (): any[] => {
    const columns: any[] = [
      {
        title: 'Client',
        key: 'client',
        dataIndex: 'name',
        width: multiSelectMode ? 570 : 500,
        sorter: (a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        },
        render: (_, row) => {
          return (
            <div className={styles.client}>
              <Avatar
                className={styles.avatarWrap}
                avatarClassName={styles.avatar}
                src={row.AvatarUrl}
                placeholder={convertNameToAvatarPlaceholder(
                  `${row.FirstName}${row.LastName ? ` ${row.LastName}` : ''}`,
                )}
              />
              <div className={styles.name}>{`${row.FirstName}${
                row.LastName ? ` ${row.LastName}` : ''
              }`}</div>
            </div>
          );
        },
      },
      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        sorter: (a, b) => {
          if (a.status < b.status) return -1;
          if (a.status > b.status) return 1;
          return 0;
        },
        width: 170,
        render: (_, row) => {
          return <div className={styles.text}>{getClientStatus(row)}</div>;
        },
      },
      {
        title: 'Focus',
        key: 'focus',
        dataIndex: 'focus',
        sorter: (a, b) => {
          if (a.focus < b.focus) return -1;
          if (a.focus > b.focus) return 1;
          return 0;
        },
        width: 200,
        render: (_, row) => {
          return <div className={styles.text}>{getClientFocus(row)}</div>;
        },
      },
      {
        title: '',
        key: 'view',
        width: 100,
        render: (_, row) => {
          return (
            <ClientActionsMenu
              client={row}
              handleReassignClick={handleReassignClick}
              limitedAccess={limitedAccess}
            />
          );
        },
      },
    ];

    if (multiSelectMode)
      columns.push({
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <Checkbox
              type="checkbox"
              name="isPrimary"
              className="mosaikCheckbox"
              value={
                clientsIds.length > 0 && clientsIds.every((id) => selectedClientIds.includes(id))
              }
              onChange={(e) => handleMainCheckboxChange(e)}
              checked={
                clientsIds.length > 0 && clientsIds.every((id) => selectedClientIds.includes(id))
              }
            />
          );
        },
        width: 30,
        render: (_, row) => {
          return (
            <Checkbox
              type="checkbox"
              name="isPrimary"
              className="mosaikCheckbox"
              value={selectedClientIds.includes(row.Id)}
              onChange={(e) => handleCheckboxChange(e, row)}
              checked={selectedClientIds.includes(row.Id)}
            />
          );
        },
      });

    return columns;
  };

  return (
    <Table
      className={styles.clientsTable}
      bordered={false}
      columns={getColumns()}
      dataSource={clients.map((item, key) => ({
        ...item,
        key,
        status: getClientStatus(item),
        focus: getClientFocus(item),
        name: `${item.FirstName}${item.LastName ? ` ${item.LastName}` : ''}`,
      }))}
      pagination={false}
    />
  );
};

export default TeamMemberClientsTable;
